export const SWAP_CONTRACT_ADDRESS =
  "0x4F367FA8D45BB782337Ae07e4f11E1b48b116217";
